import pkg from 'js-sha3';
const { sha3_256 } = pkg;

export const hashFullData = (data) => {
  const hash = '0x' + sha3_256(data).toUpperCase();
  return hash;
};
